import { ALBUM_SUBTYPE } from '../../../../constants/albums';

export const FEATURE_PERMISSION_TYPE = {
  PURCHASED_EVENT_FEATURES: 'PURCHASED_EVENT_FEATURES',
  SEARCH_SUBSCRIPTION_FEATURE: 'SEARCH_SUBSCRIPTION_FEATURE',
  PURCHASED_EVENT_ADDON_FEATURES: 'PURCHASED_EVENT_ADDON_FEATURES',
};

export const PURCHASED_EVENT_FEATURES = {
  video_guestbook_enabled: 'video_guestbook_enabled',
  slideshow_enabled: 'slideshow_enabled',
  free_joins_enabled: 'free_joins_enabled',
  joins_enabled: 'joins_enabled',
  custom_hashtag_enabled: 'custom_hashtag_enabled',
  join_code_enabled: 'join_code_enabled',
  qr_code_enabled: 'qr_code_enabled',
  marketing_prints_enabled: 'marketing_prints_enabled',
  white_label_marketing_prints_enabled: 'white_label_marketing_prints_enabled',
  photo_watermark_enabled: 'photo_watermark_enabled',
  custom_tags_enabled: 'custom_tags_enabled',
  face_highlights_enabled: 'face_highlights_enabled',
  members_view_enabled: 'members_view_enabled',
  memory_book_enabled: 'memory_book_enabled',
};

export const SEARCH_SUBSCRIPTION_FEATURES = {
  free_joins_enabled: 'free_joins_enabled',
  qr_code_enabled: 'qr_code_enabled',
  marketing_prints_enabled: 'marketing_prints_enabled',
  white_label_marketing_prints_enabled: 'white_label_marketing_prints_enabled',
  photo_watermark_enabled: 'photo_watermark_enabled',
  slideshow_enabled: 'slideshow_enabled',
  video_album_enabled: 'video_album_enabled',
  members_view_enabled: 'members_view_enabled',
  custom_tags_enabled: 'custom_tags_enabled',
  face_highlights_enabled: 'face_highlights_enabled',
  prints_discount_enabled: 'prints_discount_enabled',
  owned_content_free_joins_enabled: 'owned_content_free_joins_enabled',
};

export const PURCHASED_EVENT_ADDON_FEATURES = {
  free_joins_enabled: 'free_joins_enabled',
  qr_code_enabled: 'qr_code_enabled',
  marketing_prints_enabled: 'marketing_prints_enabled',
  white_label_marketing_prints_enabled: 'white_label_marketing_prints_enabled',
  photo_watermark_enabled: 'photo_watermark_enabled',
  slideshow_enabled: 'slideshow_enabled',
  video_album_enabled: 'video_album_enabled',
  members_view_enabled: 'members_view_enabled',
  custom_tags_enabled: 'custom_tags_enabled',
  face_highlights_enabled: 'face_highlights_enabled',
  prints_discount_enabled: 'prints_discount_enabled',
  memory_book_enabled: 'memory_book_enabled',
  owned_content_free_joins_enabled: 'owned_content_free_joins_enabled',
  custom_hashtag_enabled: 'custom_hashtag_enabled',
  join_code_enabled: 'join_code_enabled',
  multi_date_enabled: 'multi_date_enabled',
  require_review: 'require_review',
};

/**
 * Determines if the given sub type is part of the Freemium system sub types.
 *
 * @param {String} albumSubtype the album sub type
 * @returns {boolean}
 */
export const isFreemiumSubtype = albumSubtype => {
  return [
    ALBUM_SUBTYPE.BIRTHDAYS,
    ALBUM_SUBTYPE.ANNIVERSARIES,
    ALBUM_SUBTYPE.GRADUATIONS,
    ALBUM_SUBTYPE.MEMORIALS,
    ALBUM_SUBTYPE.VACATIONS,
    ALBUM_SUBTYPE.FUNDRAISERS,
    ALBUM_SUBTYPE.CUSTOM_EVENT,
    ALBUM_SUBTYPE.WEDDINGS,
  ].includes(albumSubtype);
};
